<script setup lang="ts">
</script>

<template>
  <div class="w-full xl:h-full flex flex-col xl:gap-6 gap-4 xl:p-6 p-4 pb-24">
    <NuxtLink
      to="/pricing"
      class="md:hidden fixed z-[9] left-0 w-full bottom-0 bg-white"
    >
      <Divider class="m-0" />

      <div class="p-4">
        <Button
          outlined
          severity="secondary"
          class="rounded-full py-2.5 text-white bg-neutral-90 border-neutral-90 border-2 w-full flex justify-center"
        >
          <span class="xl:text-22 text-18 font-bold">
            Get full access
          </span>
        </Button>
      </div>
    </NuxtLink>

    <Card
      :class="[
        'upsell-card md:min-h-[435px] min-h-[335px] xl:h-full',
        'shadow-none !bg-yellow-50 rounded-2xl relative overflow-hidden'
      ]"
      :pt="{
        body: {
          class: 'h-full flex flex-col xl:p-8 xl:p-4 p-2'
        },
        content: {
          class: 'h-full flex flex-col p-0'
        }
      }"
    >
      <template #content>
        <div class="flex flex-col xl:justify-center xl:pl-6 gap-4 xl:w-[60%] w-full h-full">
          <div class="flex flex-col justify-center xl:max-w-[500px] gap-4 z-[1]">
            <div class="md:text-36 text-32 font-bold text-neutral-90 pt-4 px-4">
              Unlock the complete course and more.
            </div>

            <div class=" w-full md:text-20 text-18 px-4">
              Get access to all our award-winning courses and workshops and become a great clinician.
            </div>

            <div class="md:flex hidden w-full mt-4 px-4">
              <NuxtLink to="/pricing">
                <Button
                  outlined
                  severity="secondary"
                  class="rounded-full py-2.5 text-white bg-neutral-90 border-neutral-90 border-2"
                >
                  <span class="xl:text-22 text-18 font-bold">
                    Get full access
                  </span>
                </Button>
              </NuxtLink>
            </div>
          </div>
        </div>
      </template>
    </Card>

    <div>
      <!--      <div class="overflow-x-auto no-scrollbar">-->
      <div class="grid md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4">
        <UpsellCardAchievement
          title="Internationally accredited"
          class="min-w-[300px]"
        >
          CME accredited in the USA and EU with mutual recognition agreements in most other countries.
        </UpsellCardAchievement>

        <UpsellCardAchievement
          title="Trusted institutional partner"
          class="min-w-[300px]"
        >
          Used by residency programs and universities around the world to train their clinicians and students.
        </UpsellCardAchievement>

        <UpsellCardAchievement
          title="Top-rated by our learners"
          class="min-w-[300px]"
        >
          Rated excellent by hundreds of users on <a
            href="https://www.trustpilot.com/review/www.medmastery.com"
            target="_blank"
            class="text-current underline"
          >Trustpilot</a>, an independent reviewing platform.
        </UpsellCardAchievement>

        <UpsellCardAchievement
          title="Winner of the Comenius EduMedia Seal"
          class="min-w-[300px]"
        >
          For outstanding digital education—Berlin 2017
        </UpsellCardAchievement>
      </div>
    </div>
    <!--    </div>-->
  </div>
</template>

<style lang="scss">
@import '@mui/assets/styles/utility.scss';

.upsell-card {
  background-image: url('assets/images/illustrations/upsell/upsell-mobile@2x.png');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;

  @screen xl {
    background-image: url('assets/images/illustrations/upsell/upsell-desktop@2x.png');
    background-position: right;
  }
}
</style>